import React from 'react';
interface ARWMButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
}
export function ARWMButton({
  children,
  variant = 'primary',
  className = '',
  ...props
}: ARWMButtonProps) {
  const baseStyles = 'px-6 py-4 font-josefin text-sm uppercase tracking-[3.2px] transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed rounded-none';
  const variantStyles = {
    primary: 'bg-arwm-maroon text-arwm-cream hover:bg-arwm-maroon-dark',
    secondary: 'bg-transparent border-2 border-arwm-maroon text-arwm-maroon hover:bg-arwm-maroon hover:text-arwm-cream'
  };
  return <button className={`${baseStyles} ${variantStyles[variant]} ${className}`} {...props} data-id="element-28">
      {children}
    </button>;
}